import { CutPizzaIcon, MakeDoughIcon } from '../../assets';
import { SvgComponent } from '../../types/common';
import { ContentItemActionType } from '../../api/types';

export const ACTION_TO_ICON_MAP: Record<ContentItemActionType, SvgComponent> = {
  [ContentItemActionType.Cut]: CutPizzaIcon,
  [ContentItemActionType.Make]: MakeDoughIcon,
};

export const LIST_IMAGE_SIZE = 120;
